import React, { Component } from 'react';
import * as Lang from '../lang'; 
import { setCookie } from '../utils/cookies';
class LogoutPage extends Component { 
  componentDidMount() {
    document.title = Lang.LANG_TITLE;
    setCookie('token', ""); 
    localStorage.removeItem('name');
    localStorage.removeItem('token'); 
    window.location.replace("/login");
  }

  render() { 
    return (
      <div>
        Đang đăng xuất...
      </div>
    );
  }
}  
export default LogoutPage;